// extracted by mini-css-extract-plugin
export default {"drawer":"EditInterviewScriptTemplate_drawer__PN6uW"};